import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import ConfigCard from './ConfigCard';
import { ChipsBox, ChipToggle, AvailableChip } from './_PdiHelpers';

// Category levels the storefront knows. The breadcrumb is built by picking
// any subset and ordering them — same chip-DnD pattern as Product title.
const ALL_LEVELS = [
    { key: 'gender',     i18nKey: 'cfg_pdi_breadcrumb_gender',     fallback: 'Gender'     },
    { key: 'type',       i18nKey: 'cfg_pdi_breadcrumb_type',       fallback: 'Type'       },
    { key: 'subtype',    i18nKey: 'cfg_pdi_breadcrumb_subtype',    fallback: 'Subtype'    },
    { key: 'collection', i18nKey: 'cfg_pdi_breadcrumb_collection', fallback: 'Collection' },
    { key: 'brand',      i18nKey: 'cfg_pdi_breadcrumb_brand',      fallback: 'Brand'      },
];
const DEFAULTS = ['subtype', 'type'];

const CategoryBreadcrumbCard = ({ value = {}, onChange, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);

    const used   = Array.isArray(value.used) ? value.used : DEFAULTS;
    const usedSet = new Set(used);
    const available = ALL_LEVELS.filter(l => !usedSet.has(l.key)).map(l => l.key);

    const setUsed = (newUsed) => onChange && onChange('used', newUsed);

    const labelFor = (k) => {
        const meta = ALL_LEVELS.find(l => l.key === k);
        return meta ? tr(meta.i18nKey, meta.fallback) : k;
    };

    return (
        <ConfigCard
            title={tr('cfg_pdi_breadcrumb_title', 'Category breadcrumb')}
            description={tr('cfg_pdi_breadcrumb_desc', 'The category trail shown on the product page so visitors can easily filter back.')}
            theme={theme}
        >
            <ChipsBox>
                {used.map(k => (
                    <ChipToggle
                        key={k}
                        label={labelFor(k)}
                        onRemove={() => setUsed(used.filter(x => x !== k))}
                    />
                ))}
                {used.length === 0 && (
                    <Typography variant="caption" sx={{ color: 'text.disabled', fontStyle: 'italic', px: 1, py: 0.5 }}>
                        {tr('cfg_pdi_breadcrumb_empty', 'No levels — pick from the available row below.')}
                    </Typography>
                )}
            </ChipsBox>
            {available.length > 0 && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 1 }}>
                    {available.map(k => (
                        <AvailableChip
                            key={k}
                            label={labelFor(k)}
                            onAdd={() => setUsed([...used, k])}
                        />
                    ))}
                </Box>
            )}
        </ConfigCard>
    );
};

CategoryBreadcrumbCard.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default CategoryBreadcrumbCard;
